import HttpRequest from '../request'
import { LegacyEnterpriseApi } from '../api'
import type { Response } from '../request'
import type { LegacyTouchState, LegacyInvite, LegacyWorkspaceSummary, LegacyMemberResult } from './types'

export default {
  workspaceSummary: (): Promise<Response<LegacyWorkspaceSummary>> => HttpRequest.get(LegacyEnterpriseApi.workspaceSummary, {}, { timeout: 15000 }),
  memberStatus: (teamId: number, requestId: string): Promise<Response<LegacyMemberResult>> => HttpRequest.get(LegacyEnterpriseApi.memberStatus, { teamId, requestId }, { timeout: 15000 }),
  state: (): Promise<Response<LegacyTouchState>> => HttpRequest.get(LegacyEnterpriseApi.touchState, {}, { timeout: 15000 }),
  visit: (): Promise<Response<LegacyTouchState>> => HttpRequest.post(LegacyEnterpriseApi.visit, {}),
  defer: (migrationNo: string): Promise<Response<boolean>> => HttpRequest.post(LegacyEnterpriseApi.defer, { migrationNo }),
  invite: (migrationNo: string): Promise<Response<LegacyInvite>> => HttpRequest.get(LegacyEnterpriseApi.invite, { migrationNo }),
}
